module.exports = __webpack_public_path__ + "img/cama-1plaza.cf619d06.svg";